// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"tq-z","breadcrumbForward":"uq-z","breadcrumbBack":"vq-z","selected":"wq-z"};